// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-4b7944a4]{font-family:var(--brand-font-regular)}[data-v-4b7944a4]:host{all:initial}.error[data-v-4b7944a4]{max-width:800px;margin:10px auto;border:1px dashed red;padding:5px 0}.max-view-wide[data-v-4b7944a4]{max-width:1599px}.max-view-contained[data-v-4b7944a4]{max-width:1279px}.max-view-fullWidth[data-v-4b7944a4]{max-width:100%}.max-view-mobile[data-v-4b7944a4]{max-width:640px}", ""]);
// Exports
module.exports = exports;
